import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { PlanningTuning } from '@shared/models/planningTuning.model';
import { PlanningTuningLogs } from '@shared/models/planningTuningLogs.model';
import { PlanningTuningStats } from '@shared/models/planningTuningStats.model';
import { urlEndPoints } from '../config/end-points';

@Injectable({
  providedIn: 'root',
})
export class PlanningTuningDal {
  constructor(private httpClient: HttpClient) {}

  addPlanningTuningConfiguration(planningConfig: PlanningTuning): Observable<PlanningTuning> {
    return this.httpClient.put<PlanningTuning>(urlEndPoints.planningTunings + 'add', planningConfig);
  }

  updatePlanningTuningConfiguration(planningConfig: PlanningTuning): Observable<PlanningTuning> {
    return this.httpClient.put<PlanningTuning>(urlEndPoints.planningTunings + 'update', planningConfig);
  }

  getPlanningConfigs(hospital: string, startDate: string, endDate: string): Observable<any> {
    return this.httpClient.get<PlanningTuning>(
      urlEndPoints.planningTunings + `getPlanningConfigs/${hospital}?startDate=${startDate}&endDate=${endDate}`
    );
  }

  validatePlanning(planningConfigId: string): Observable<any> {
    return this.httpClient.post<PlanningTuning>(urlEndPoints.planningTunings + 'validateAdjustedPlanning', {
      planningConfigId,
    });
  }

  getPlanningTuningLogs(configId: string): Observable<PlanningTuningLogs[]> {
    return this.httpClient.get<PlanningTuningLogs[]>(
      urlEndPoints.planningTunings + `getPlanningTuningLogs/${configId}`
    );
  }

  getPlanningTuningStats(configId: string): Observable<PlanningTuningStats> {
    return this.httpClient.get<PlanningTuningStats>(
      urlEndPoints.planningTunings + `getPlanningTuningStats/${configId}`
    );
  }

  getNeedsCoverage(configId: string): Observable<any> {
    return this.httpClient.get<any>(urlEndPoints.planningTunings + `getNeedsCoverage/${configId}`);
  }

  getPlanningTuning(configId: string): Observable<any> {
    return this.httpClient.get<any>(urlEndPoints.planningTunings + `getPlanningTuning/${configId}`);
  }
}
